import { useTranslation } from "react-i18next";
import GModal from "./Modal";
import * as FiIcons from "react-icons/fi";
import { Box, Flex, Heading, Spinner } from "@chakra-ui/react";
import GButton from "../button/Button";

const DeleteModal = ({
  onClose,
  onSubmit,
  isLoading = false,
}) => {
  const { t } = useTranslation();

  return (
    <GModal
      modalHeader={t("general.delete")}
      onClose={onClose}
      modalContent={(
        isLoading ? (
          <Flex bg="light" p={4} justifyContent="center">
            <Spinner />
          </Flex>
        ) : (
          <Box p={6}>
            <Heading
              as="h4" fontSize="1.3rem" mb={6} textTransform="capitalize"
            >
              {t("general.delete_item")}
            </Heading>
            <Flex gap={4}>
              <GButton
                title={t("general.delete")}
                prefixElement={<FiIcons.FiTrash2 size={16} />}
                bg="red.600"
                border="1px solid transparent"
                color="light"
                hover={{ color: "red.600", borderColor: "red.600", bg: "none" }}
                onClick={onSubmit}
              />
              <GButton
                title={t("general.close")}
                prefixElement={<FiIcons.FiMinimize size={16} />}
                bg="none"
                color="dark"
                border="1px solid"
                borderColor="border"
                hover={{ color: "red.600", borderColor: "red.600", bg: "none" }}
                onClick={onClose}
              />
            </Flex>
          </Box>
        )
      )}
    />
  )
}

export default DeleteModal